<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "CommodityIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
